/* eslint-disable */
module.exports = require('./configureStore.' + process.env.NODE_ENV)
